import React from "react";
import config from "../../config";
import { Link } from "gatsby";

export default function Footer() {
  return (
    <footer className="text-white footer">
      <div className="container">
        <div className="footerTop">
          <div className="row">
            <div className="col-lg-3 p-3">
              <p>
                <strong>PckitUp</strong>
              </p>
              <ul className="list-unstyled p-0">
                <li>
                  <Link
                    to="/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    home
                  </Link>
                </li>
                <li>
                  <Link
                    to="/agent/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    agent
                  </Link>
                </li>
                <li>
                  <Link
                    to="/customer/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    customer
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    about
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 p-3">
              <p>
                <strong>support</strong>
              </p>
              <ul className="list-unstyled p-0">
                <li>
                  <Link
                    to="/apply/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    apply
                  </Link>
                </li>
                <li>
                  <Link
                    to="/faq/"
                    className="nav-link pl-0"
                    activeClassName="active"
                  >
                    faq
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3 p-3">
              <p>
                <strong>follow us</strong>
              </p>
              <ul className="list-unstyled p-0 IconUL">
                {config.socialLinks.map((social) => {
                  const { icon, url } = social;
                  return (
                    <li key={icon}>
                      <a
                        href="#"
                        className={`fab ${icon} text-decoration-none socialIcons`}
                      />
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="col-lg-3 p-3">
              <p>
                <strong>apply</strong>
              </p>
              <ul className="list-unstyled p-0 m-0">
                <li>
                  <a
                    href="/apply/#agent"
                    className="btn btn-primary footerButton footerButtonAgent"
                  >
                    Agent app
                  </a>
                </li>
                <li className="m-0">
                  <a
                    href="/apply/#customer"
                    className="btn btn-success footerButton footerButtonCustom m-0"
                  >
                    Customer app
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footerBottom text-center">
          <p className="m-0">&copy; 2020 PckitUp, Inc. all rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
